<div class="card-cell-header">
	@if (jaren_onvoldoende_class) {
		<div [class]="jaren_onvoldoende_class"></div>
	}
	<span class="card-cell-title">{{ title }}</span>
	@if (variant === DashboardVariant.ACTUEEL && title === "Examencijfers" && [2022, 2023, 2024].includes(peiljaar) && aantalJaren > 3) {
		<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="getExamencijfersTooltip()"></app-icon>
	}
</div>
@if (rows.length > 0) {
	<div [class.card-cell-column]="variant === DashboardVariant.ACTUEEL" [class.card-cell-row]="variant === DashboardVariant.HISTORIE">
		@for (row of rows; track row) {
			<div [appTooltip]="row.actueelRow?.tooltip">
				<ng-container
					[ngTemplateOutlet]="template"
					[ngTemplateOutletContext]="{
						cellRow: row,
					}"
				></ng-container>
			</div>
		}
	</div>
} @else {
	@switch (title) {
		@case ("Examencijfers") {
			<span class="geen-score">Geen examencijfers beschikbaar</span>
		}
		@default {
			<span class="geen-score">Geen score beschikbaar</span>
		}
	}
}
